// extracted by mini-css-extract-plugin
export default {"page":"ProjectsPage_page__rY-49"};